import getTokens from './getToken'
export default{
    
    set: function (name, value, days) {
        var d = new Date;
        d.setTime(d.getTime() + 24*60*60*1000*days);
        window.document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    },
    
    get: function (name) {
        var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    },

    deletes: function (name) {
        this.set(name, '', -1);
    },

    getDates:function(value){
        var yy = value.getFullYear();      //年
        var mm = value.getMonth() + 1;     //月
        var dd = value.getDate();          //日
        var clock = yy + "-";
        if(mm < 10) clock += "0";
        clock += mm + "-";
        if(dd < 10) clock += "0";
        clock += dd;
        return clock
    },

    tokenIsTrue: function (vm,error) {
        if(JSON.parse(JSON.stringify(error)).message.indexOf('401') != -1){
            if(vm.GLOBAL.getToken){
                this.deletes('token')
                vm.GLOBAL.getToken = false
                if(this.get('reToken')){
                    getTokens(vm)
                }else{
                    vm.$Message.warning('登录超时，请重新登录！');
                    vm.$router.push({
                        path: '/'
                    });
                    vm.deletes('reToken');
                    vm.deletes('expiresin');
                    vm.deletes('bOwnerId');
                    vm.deletes('permissions');
                    vm.deletes('userType');
                    vm.deletes('id');
                    vm.deletes('sysDepartmentId')
                }
            }
        }else{
            vm.$Message.error(error.response.data.msg);
        }
    }

}


// WEBPACK FOOTER //
// ./src/utils/common.js